import { Navigate } from 'react-router';

import { AuthStateType, useAuth } from '../hooks/useAuth';

const ONBOARDING_REDIRECT_PATHS: Record<string, string> = {
  EmailVerification: '/verify-email',
  ProfileCreation: '/publisher-access',
};

export function RootRedirect() {
  const [auth] = useAuth();

  if (
    auth.type === AuthStateType.Authenticated &&
    (auth.user.onboardingState === 'Complete' ||
      auth.user.onboardingState === 'KYB')
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  if (auth.type === AuthStateType.NoToken) {
    return <Navigate to="/auth" replace />;
  }

  if (auth.type === AuthStateType.Verifying) {
    return (
      <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
        <div className="text-white">Loading…</div>
      </div>
    );
  }

  if (auth.type === AuthStateType.Authenticated) {
    const redirectPath =
      ONBOARDING_REDIRECT_PATHS[auth.user.onboardingState] ?? '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return <Navigate to="/auth" replace />;
}
